import * as React from 'react';

export interface IMergingProps {}

export default class Merging extends React.Component<IMergingProps> {
  public render() {
    return <div>MERGE TIME</div>;
  }
}
